import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  body: {
    paddingTop: '35px',
    paddingBottom: '65px',
    paddingHorizontal: '35px',
  },
  title: {
    display: 'flex',
    justifyContent: 'center',
    fontSize: '24px',
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    textAlign: 'center',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: '10px',

    bottom: '30px',
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  pageFlow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  section: {
    border: '1px solid black',
    borderRadius: 5,
    width: '100%',
    padding: '10px',
    margin: '15px 0px',
  },
  POSection: {
    display: 'flex',
    flexDirection: 'row',
  },
  POSectionColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
  },
  poSectionItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    margin: '2px 0px',
  },
  poSectionHeading: {
    width: '50%',
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    fontSize: '10px',
  },
  poSectionValue: {
    width: '50%',
    fontSize: '10px',
  },
  sectionTitle: {
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    fontSize: '14px',

    width: '100%',
  },
  divider: {
    width: '100%',
    height: '1px',
    backgroundColor: '#aaa',
    margin: '5px 0px',
  },
  description: {
    fontSize: '10px',
  },
  contactInfo: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
  },
  contactInfoSection: {
    width: '50%',
  },
  subTitle: {
    fontSize: '12px',
    fontWeight: 'bold',
    fontFamily: 'Roboto',
    marginBottom: '10px',
  },
  LineItemsTable: {
    display: 'flex',
    flexDirection: 'column',
    padding: '5px',
    margin: '10px 0px',
  },
  table: {
    padding: '5px',
    margin: '10px 0px',
  },
  linItemsTableHeader: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#aaa',
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#aaa',
  },
  cellValue: {
    display: 'flex',
    flexDirection: 'row',
  },
  lineItemsTableHeader1: {
    backgroundColor: '#aaa',
    display: 'flex',
    flexDirection: 'row',
  },
  tableHeaderCell: {
    flex: 1,
    padding: '3px',
    fontSize: '10px',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  tableHeaderFirstCell: {
    width: 100,
    padding: '3px',
    fontSize: '10px',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  lineItemsTableHeaderCell1: {
    padding: '3px',
    fontSize: '10px',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    backgroundColor: '#aaa',
  },
  tableBody: {
    display: 'flex',
  },
  lineItemsTableBody: {
    display: 'flex',
    flexDirection: 'column',
  },
  lineItemsTableRow: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'center',
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  lineItemsTableCell: {
    flexGrow: 1,
    padding: '3px',
    fontSize: '9px',
    backgroundColor: '#fff',
    textAlign: 'center',
  },
  tableCell: {
    flex: 1,
    padding: '3px',
    fontSize: '9px',
  },
  tableRowCell: {
    flex: 4,
    padding: '3px',
    fontSize: '9px',
  },
  tableRowFirstCell: {
    width: 100,
    fontSize: '9px',
  },
  noRecords: {
    display: 'flex',
    textAlign: 'center',
    padding: '3px',
    fontSize: '10px',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
  },
});
